export class CreateBackupPolicyResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "backupPolicy",
            "baseName": "backupPolicy",
            "type": "BackupPolicy",
            "format": ""
        },
        {
            "name": "actionApprovalRequest",
            "baseName": "actionApprovalRequest",
            "type": "MPARequest",
            "format": ""
        },
        {
            "name": "mpaPolicies",
            "baseName": "mpaPolicies",
            "type": "MPAPoliciesInfo",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateBackupPolicyResponse.attributeTypeMap;
    }
    constructor() {
    }
}
